import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from '../styles';

interface LabelProps {
	label?: string;
}

export function Label({ label }: Readonly<LabelProps>) {
	return (
		<S.LabelSpan>
			{I18n.get(label)}
			<S.RequiredAsterisk>*</S.RequiredAsterisk>
		</S.LabelSpan>
	);
}
